/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Usettings_Memory_LabelInputs */



/**
* | output |
* | --- |
* | "Let Uno remember" |
*
* @param {Uno_Usettings_Memory_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_usettings_memory_label = /** @type {((inputs?: Uno_Usettings_Memory_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Usettings_Memory_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Uno darf sich etwas merken")
	return /** @type {LocalizedString} */ ("Let Uno remember")
});